import React from 'react';
import { FormattedMessage } from 'react-intl';

import Constants from '../../../../definitions/constants';
import FormatTooling from '../../../../tooling/formatTooling';
import { intl } from '../../../../locales/localesConfig';

const VersionsTable = props => {
  const {
    className,
    versions,
    onClickVersion,
    handleDelete,
    handleRestore,
  } = props;
  return (
    <div className={"table_component versions_table_component" + (className ? " " + className : "")}>
      <div className="versions_table_component_label">
        <FormattedMessage id="common.versions.label"/>
      </div>
      <div className="table_component_table_wrapper">
        <div className="table_component_table_header_wrapper">
          <table>
            <thead>
              <tr>
                <th><div><FormattedMessage id="common.versions.columns.date"/></div></th>
              </tr>
            </thead>
          </table>
        </div>
        <div className="table_component_table_body_wrapper">
          <table>
            <thead>
              <tr><th>{""}</th></tr>
            </thead>
            <tbody>
            {versions && versions.map((version,i) => {
              return (
                <tr  
                  className={"clickable_row" + (i==0 ? " formula_version_current_version" : " formula_version")}
                  onClick={onClickVersion}
                  data-entitydata={JSON.stringify(version)}
                  key={i}
                >
                  <td>
                    <div>{FormatTooling.defaultsTextFormatTypes(version.created_at,Constants.crudGenerator.dataTypes.DATETIME, true)}</div>
                  </td>                  
                  <td className="action_column">
                    {(handleRestore && i!=0) && (
                      <i 
                        data-id={JSON.stringify(version.id)}
                        data-entitydata={JSON.stringify(version)}
                        className="fas restore-action fa-undo"
                        onClick={handleRestore}
                        title={intl.formatMessage({ id: "common.entityTableActions.restore"})}
                      />
                    )}
                    {(handleDelete && i!=0) && (
                    <i 
                      data-id={JSON.stringify(version.id)}
                      data-entitydata={JSON.stringify(version)}
                      className="fas delete-action fa-trash"
                      onClick={handleDelete}
                      title={intl.formatMessage({ id: "common.entityTableActions.delete"})}
                    />
                    )}
                    {(i==0) && (
                      <FormattedMessage id="polynomialAdmin.versionsTableCurrentVersion"/>
                    )}
                  </td>
                </tr>                      
              );    
            })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default VersionsTable;



// WEBPACK FOOTER //
// ./source/client/components/common/versions/versionsTable.jsx